if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.currentVariant = null;
      this.cartesian = null;
      this.areAllSelectionsMade = false;
    }
    
    connectedCallback() {
      this.locale = this.dataset.locale == 'false' ? false : this.dataset.locale;
      this.giftCard = this.dataset.giftCard == 'true' ? true : false;
      this.cartesian = JSON.parse(this.querySelector('template[data-cartesian]')?.content.textContent ?? '[]');
      this.atcButton = this.querySelector('[data-action="add-to-cart"]');
      this.notifyButton = this.querySelector('#attn-waitlist-trigger');
      this.stickyATC = this.querySelector('[data-sticky-atc] button');
      this.productData = this.dataset.product;
      this.form = this.querySelector(`form`);      
      this.soldOutState = this.dataset.soldOutState == 'true' ? true : false

      if (!this.cartesian) return;
      this.classList.toggle('in-view', isInViewport(this));
      this.calculateAvailabilityOfPartiallyMatchingVariants();
      this.selectFirstOptionIfGiftCard();
                  
      let optionsPersisted = true;
      window.selectedOptionsToPersist?.forEach((option, i) => {       
        const optionSelector = this.querySelector(`[data-action="option-choice"][data-option="${option}"]`);
        
        if (optionSelector) {
          optionSelector.checked = true;
          this.querySelector(`[data-option-selection="${optionSelector.dataset.position}"]`).innerText = option;
        } else optionsPersisted = false;
        
        if (!optionsPersisted) return;
        this.currentVariant = this.cartesian[this.getCurrentOptionSet()] || null;
        if (this.currentVariant) {
          if (!this.locale) window.bwp?.updateWidget(this.currentVariant.variant_json?.sku, 1, Object.values(this.cartesian).map(v => v.variant_json?.sku));
          window.dispatchEvent(new CustomEvent('productForm:skuChange', { detail: { skuCode: this.currentVariant.variant_json.sku }}));
          this.updatePriceDisplay();
          window.dispatchEvent(new CustomEvent('dataLayer:color_change', { detail: { selected: this.productData, current: this.currentVariant?.variant_json }}));
        }
        this.calculateAvailability(); 
      });
      
      window.addEventListener
      if (!this.currentVariant) {
        window.dispatchEvent(new CustomEvent('dataLayer:color_change', { detail: { selected: this.productData, current: Object.values(this.cartesian).find(v => v.default_variant).variant_json }}));
      }
      
      this.addEventListener('change', e => {
        const clickedElement = e.target.closest('[data-action]');
        if (!clickedElement) return;
        
        const {
          action,
          position,
          option
        } = clickedElement.dataset;
                
        switch (action) {
          case 'option-choice':
            this.querySelector(`[data-option-selection="${position}"]`).innerText = option;
            this.currentVariant = this.cartesian[this.getCurrentOptionSet(position, option).toString()];
            if (this.currentVariant) {
              window.selectedOptionsToPersist = [...this.getCurrentOptionSet(position, option)];
            }
            this.calculateAvailability();
            this.updatePriceDisplay();

            window.dispatchEvent(new CustomEvent('productForm:sizeChange', { detail: { sizeCode: `${this.getCurrentOptionSet().map(x => x)}` }}));
            if (this.currentVariant) {
              window.dispatchEvent(new CustomEvent('dataLayer:size_select', { detail: { selected: this.productData, current: this.currentVariant?.variant_json }}));
              if (!this.locale) window.bwp?.updateWidget(this.currentVariant.variant_json.sku, 1, Object.values(this.cartesian).map(v => v.variant_json.sku));
              window.dispatchEvent(new CustomEvent('productForm:skuChange', { detail: { skuCode: this.currentVariant.variant_json.sku }}));
            }
          break;
        }
      });
      
      this.addEventListener('submit', e => {
        if (!e.target.closest('form[action="/cart/add"]') || this.currentVariant || this.getCurrentOptionSet().length == 1) {
          return;
        }
                
        e.stopImmediatePropagation;
        e.stopPropagation();
        e.preventDefault();
        
        this.classList.add('selection-needed');        
      });
      
      function isInViewport(element) {
        var rect = element.getBoundingClientRect();
        var html = document.documentElement;
        return (
          rect.top > window.scrollY ||
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || html.clientHeight) &&
          rect.right <= (window.innerWidth || html.clientWidth)
        );
      }
      
      window.addEventListener('scroll', () => {
        this.classList.toggle('in-view', isInViewport(this));
      });
    }

    selectFirstOptionIfGiftCard() {
      if (this.giftCard) {
        const firstOption = this.querySelector('[data-action="option-choice"]');
        if (firstOption) {
          firstOption.checked = true;
          this.querySelector(`[data-option-selection="${firstOption.dataset.position}"]`).innerText = firstOption.value;
          this.currentVariant = this.cartesian[this.getCurrentOptionSet(firstOption.dataset.position, firstOption.value).toString()];
          this.calculateAvailability();
          this.updatePriceDisplay();
        }
      }
    }
    
    calculateAvailability() {
      this.areAllSelectionsMade = !this.querySelector(`[data-selector-group]:not(:has([data-action="option-choice"]:checked))`);
      this.classList.remove('prime-only');
      
      if(this.soldOutState) {
        this.querySelector('[type="submit"][data-action="add-to-cart"]')?.setAttribute('disabled', true); 
        return;
      }
      if (!this.areAllSelectionsMade) {
        this.calculateAvailabilityOfPartiallyMatchingVariants();
        this.classList.toggle('selection-needed', true);  
        return;
      } else {
        this.atcButton.classList.remove('disabled');
        this.atcButton.classList.remove('!text-white');
        this.atcButton.classList.remove('cursor-default');
        this.atcButton.classList.remove('pointer-events-none');
        this.atcButton.innerHTML = `Add to Cart &bull; ${this.dataset.currencySymbol}${(this.currentVariant.variant_json.price / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}${this.dataset.currencySymbolCode !== `USD` ? ` ${this.dataset.currencySymbolCode}` : ``}`;
        this.stickyATC?.setAttribute('form', this.form.getAttribute('id'));
        this.stickyATC?.removeAttribute('onClick');
        
        this.querySelectorAll('[data-action="option-choice"]').forEach((optionChoice) => {         
          const { position, option } = optionChoice.dataset;
          const thisVariant = this.getMatchingVariant(position, option);
          if (!this.areAllSelectionsMade && optionChoice.closest(`[data-selector-group]:has([data-action="option-choice"]:checked)`)) return;
          optionChoice.nextElementSibling.classList.toggle('unavailable', !thisVariant?.variant_json.available);
        }); 
      }
      
      if (this.currentVariant?.variant_json.available) {
        this.querySelector('[type="submit"][data-action="add-to-cart"]')?.removeAttribute('disabled');
      } else this.querySelector('[type="submit"][data-action="add-to-cart"]')?.setAttribute('disabled', true);
            
      this.classList.toggle('selection-needed', false);  

      if (!this.currentVariant) return;
      this.classList.toggle('prime-only', this.currentVariant.prime_only == 'true');
      this.querySelector('select[name="id"]').value = this.currentVariant.variant_json.id;
      if (this.querySelector('[data-variant-selector]')) this.querySelector('[data-variant-selector]').innerText = this.getCurrentOptionSet();
    }
    
    updatePriceDisplay() {
      if (!this.currentVariant) return;
      const priceDisplays = this.closest('sparky-shuffle')?.querySelectorAll('[data-price]');      
      priceDisplays.forEach((el) => {
        if (Number(this.currentVariant.variant_json.compare_at_price) > Number(this.currentVariant.variant_json.price)) {
          const saleMessaging = el.querySelector('[data-sale-messaging]');
          el.innerHTML = `
          <span class="line-through">
            ${this.dataset.currencySymbol}${Number(this.currentVariant.variant_json.compare_at_price / 100)
              .toFixed((this.currentVariant.variant_json.compare_at_price % 100) ? 2 : 0)}
          </span>
          ${saleMessaging ? `<span data-sale-messaging class="text-torchRed -mr-1">${saleMessaging.innerHTML}</span>` : ''}
          <span class="text-torchRed font-medium">
            ${this.dataset.currencySymbol}${Number(this.currentVariant.variant_json.price / 100)
              .toFixed((this.currentVariant.variant_json.price % 100) ? 2 : 0)}
          </span>
        `;
        return;
        }
        
        el.innerHTML = `<span>${this.dataset.currencySymbol}${Number(this.currentVariant.variant_json.price / 100)
          .toFixed((this.currentVariant.variant_json.price % 100) ? 2 : 0)}</span>`;
      });
    }
    
    getCurrentOptionSet(position, option) {
      let thisOptionSet;
        thisOptionSet = [...this.querySelectorAll('[data-action="option-choice"][data-option]:checked')].map(({ value }) => value);
      if (position && option) {
        const optionIndex = Number(position) - 1;
        thisOptionSet[optionIndex] = option;
      }
      return thisOptionSet;
    }
    
    calculateAvailabilityOfPartiallyMatchingVariants() {
      if(this.soldOutState) {
        this.querySelector('[type="submit"][data-action="add-to-cart"]')?.setAttribute('disabled', true); 
        return;
      }
      const selectedOptionValues = this.getCurrentOptionSet();
      const unselectedOptionElements = this.querySelectorAll('[data-selector-group]:not(:has([data-action="option-choice"]:checked)) [data-action="option-choice"]');
      const allCartesianKeys = Object.keys(this.cartesian);
    
      unselectedOptionElements.forEach((input) => {
        const cartesianSet = [input.value, ...selectedOptionValues];
        const matchingKeys = allCartesianKeys.filter((key) => {
          const splitKey = key.split(',');
          return cartesianSet.every(value => splitKey.includes(value));
        });
        const isAvailable = matchingKeys.some(key => this.cartesian[key].variant_json.available);
    
        input.nextElementSibling.classList.toggle('unavailable', !isAvailable);
      });
    }
    
    getMatchingVariant(position, option) {
      const optionIndex = Number(position) - 1;
      let thisOptionSet = this.getCurrentOptionSet();
      thisOptionSet[optionIndex] = option;
            
      return this.cartesian[thisOptionSet.toString()]
    }
  }
  
  customElements.define('product-form', ProductForm);
}